import React from 'react';
import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';
import useHasHydrated from '@/hooks/use-has-hydrated';

import IconRefresh from '@/components/Icons/IconRefresh';

import ProfileCard from './ProfileCard';
import ProfileLoader from './ProfileLoader';

function SoloProfileCard({}) {
  const [key, setKey] = React.useState(0);
  const [isEngaged, setIsEngaged] = React.useState(false);

  const hasHydrated = useHasHydrated();

  return (
    <OuterWrapper>
      <Wrapper>
        {hasHydrated ? (
          <ProfileCard key={'render' + key} />
        ) : (
          <ProfileLoader />
        )}
        <RefreshButton
          onClick={() => {
            setKey(key + 1);
            setIsEngaged(false);
          }}
          onMouseDown={() => setIsEngaged(true)}
          onMouseLeave={() => setIsEngaged(false)}
        >
          <IconRefresh isBooped={isEngaged} changeKey={key} />
        </RefreshButton>
      </Wrapper>
    </OuterWrapper>
  );
}

const OuterWrapper = styled.div`
  display: flex;
  justify-content: center;
  overflow: auto;
  margin: 0 -16px 32px;

  @media ${BREAKPOINTS.smAndSmaller} {
    justify-content: flex-start;
  }
`;

const Wrapper = styled.div`
  position: relative;
  width: 24rem;
  min-width: 24rem;
  padding: 16px 16px 16px;
  container-type: inline-size;
`;

const RefreshButton = styled.button`
  position: absolute;
  top: 16px;
  right: -24px;
  transform: translateX(100%);
  opacity: 0;
  transition: opacity 500ms;
  outline-offset: 12px;
  border-radius: 50%;

  ${OuterWrapper}:hover & {
    opacity: 1;
    transition: opacity 200ms;
    transition-delay: 300ms;
  }
  &:focus {
    opacity: 1;
    transition: opacity 100ms;
  }

  @media ${BREAKPOINTS.smAndSmaller} {
    display: none;
  }
`;

export default SoloProfileCard;
